import { Box, SxProps, Typography } from "@outschool/backpack";
import React from "react";

interface ComposerUnavailableNoticeProps {
  message: string;
  sx?: SxProps;
}

export default function ComposerUnavailableNotice({
  message,
  sx,
}: ComposerUnavailableNoticeProps) {
  return (
    <Box
      sx={{
        borderTop: "1px solid",
        borderColor: "divider",
        ...sx,
      }}
    >
      <Typography variant="body2" color="text.secondary">
        {message}
      </Typography>
    </Box>
  );
}
